export enum TelemetryDeliveryMethod {
  Streaming = 1,
  Bulk = 2
}
